<template>
  <div>
    <div class="p-8 bg-gray-800">
      <div class="max-w-7xl mx-auto">
        <div class="md:flex md:items-center md:justify-between">
          <div class="flex-1 min-w-0">
            <h2 class="text-2xl font-bold leading-7 text-white sm:text-3xl sm:truncate">
              {{ $t('accountContacts.title') }}
            </h2>
          </div>
          <div class="mt-4 flex md:mt-0 md:ml-4 space-x-2">
            <ImportContactsAction :account-id="accountId" @created="refreshList" />
          </div>
        </div>
      </div>
    </div>
    <div class="p-8">
      <div class="max-w-7xl mx-auto">
        <ContactList ref="contactList" :account-id="accountId" />
      </div>
    </div>
  </div>
</template>

<script>
import ContactList from './contacts/components/ContactList.vue';
import ImportContactsAction from './contacts/components/ImportContactsAction.vue';

export default {
  components: {
    ImportContactsAction,
    ContactList,
  },
  props: {
    accountId: {
      type: String,
      required: true,
    },
  },
  methods: {
    refreshList() {
      this.$refs.contactList.refreshList();
    },
  },
};
</script>
